// Core
import React, { Component } from "react";
import { connect } from "react-redux";
import { cloneDeep, get } from "lodash";
import { json2csv } from "json-2-csv";
import fileDownload from "downloadjs";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import ActivityIndicator from "react-activity-indicator";
// import { NotificationManager } from "react-notifications";

// Components
import ChecklistGroup from "./ChecklistGroup";
import ChecklistCreator from "./ChecklistCreator";
import AddEditCardDialog from "./AddEditCardDialog";

// Actions
import {
  getChecklist,
  addChecklist,
  addChecklistItem,
  editChecklistItem,
  deleteChecklistItem,
  editChecklist,
  moveChecklist,
  moveChecklistItemInParent,
  moveChecklistItemToOtherList,
  deleteChecklist,
  copyChecklist,
  firstChecklist,
  IMPORT_FIELD_NAMES,
  shareChecklist,
  insertAtIndex
} from "../../redux/checklists/actions";
import { getUserProjects, getProject } from '../../redux/projects/actions';
import { track } from "../../redux/auth/actions";

// Selectors
import * as checklistsSelectors from "../../redux/checklists/selectors";
import * as authSelectors from "../../redux/auth/selectors";
import * as projectSelectors from '../../redux/projects/selectors'
import * as checklistSelectors from '../../redux/checklists/selectors'

// Instruments
import { arrayMove } from "../../utils/common";

// Styles & assets
import "./Checklist.css";
import ShareIcon from "material-ui/svg-icons/social/share";
import FlatButton from "material-ui/FlatButton";

import {getProjectLocations} from "../../redux/locations/actions";
import {search} from "../../config";
import {ISSUES_PDF_REQUEST} from "../../redux/issues/actions";

const axios = require('axios').default;

const mapStateToProps = state => ({
  checklists: checklistsSelectors.checklists(state),
  userId: authSelectors.getUserId(state),
  firstLoad: checklistsSelectors.firstLoad(state),
  projectsList: projectSelectors.projectsList(state),
  projectDetails: projectSelectors.projectDetails(state),
  checklistProjectId: checklistSelectors.checklistProjectId(state),
  isProjectOwner: checklistSelectors.isProjectOwner(state),
  isChanged: checklistSelectors.isChanged(state),
  isLoaded: checklistSelectors.isLoaded(state),
});

const mapDispatchToProps = {
  getChecklist,
  addChecklist,
  addChecklistItem,
  editChecklistItem,
  deleteChecklistItem,
  editChecklist,
  moveChecklist,
  moveChecklistItemInParent,
  moveChecklistItemToOtherList,
  deleteChecklist,
  copyChecklist,
  firstChecklist,
  track,
  getUserProjects,
  shareChecklist,
  getProject,
  getProjectLocations
};

class Checklist extends Component {
  static defaultProps = {
    isCombineEnabled: false
  };

  state = {
    columns: get(this.props.checklists, "lists"),
    ordered: get(this.props.checklists, "order"),
    activeElement: null,
    activeChecklist: null,
    isMust: '',
    section: '',


    selectedTaskIds: [],
    selectedColumnId: false,

    checklistSharingMode: false,
    checklistsToShareIds: []
  };

  componentWillReceiveProps(nextProps, nextState) {
    if (nextProps.checklists) {
      this.setState({
        ...nextState,
        columns: nextProps.checklists.lists,
        ordered: nextProps.checklists.order
      });
    }

    if (nextProps.checklistProjectId !== this.props.checklistProjectId) {
      const { userId } = JSON.parse(localStorage.getItem("auth0")) || "";
      this.props.firstChecklist(userId);

      if (nextProps.checklistProjectId !== 'PRIVATE') {
        this.props.getProject(nextProps.checklistProjectId);
        this.props.getProjectLocations(nextProps.checklistProjectId);
      }
    }
  }

  componentDidMount() {
    const { projectsList } = this.props;
    const { userId } = JSON.parse(localStorage.getItem("auth0")) || "";
    track("Web app: Checklist tab chosen");

    this.props.firstChecklist(userId);

    // if (!projectsList) {
    //   if (Object.keys(projectsList).length === 0) {
        this.props.getUserProjects(userId);
      // }
    // }

    window.addEventListener('click', this.onWindowClick);
    window.addEventListener('keydown', this.onWindowKeyDown);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.onWindowClick);
    window.removeEventListener('keydown', this.onWindowKeyDown);
  }

  onWindowKeyDown = (event) => {
    if (event.defaultPrevented) {
      return;
    }

    if (event.key === 'Escape') {
      this.setState({selectedTaskIds: [], selectedColumnId: false});
    }
  };

  onWindowClick = (event) => {
    if (event.defaultPrevented) {
      return;
    }
    this.setState({selectedTaskIds: [], selectedColumnId: false});
  };

  handleSaveDataToPrefillModal = data => this.setState({ ...data});

  onCreateCard = card => {
    const { userId, addChecklistItem, getChecklist, track } = this.props;
    const { columns, activeElement } = this.state;

    addChecklistItem(userId, activeElement.indexColumn, card).then(() => {
      track("Web app: Checklist card added");
      getChecklist(userId);
    });
    this.setState({
      // columns: {...columns, [activeElement.indexColumn]: [...columns[activeElement.indexColumn], card]},
      activeElement: null
    });
  };

  onEditCheklist = (id, checklist) => {
    const { userId, editChecklist, getChecklist } = this.props;

    editChecklist(userId, id, checklist).then(() => {
      getChecklist(userId);
    });
  };

  setActiveChecklist = checklist => {
    this.setState({ activeChecklist: checklist });
  };

  onShareChecklist = checklist => {
    this.setActiveChecklist({...checklist, IS_SHARE: true})
  };

  onShareMultiChecklist = checklist => {
    this.setActiveChecklist({...checklist, IS_SHARE: true, checklistIds: this.state.checklistsToShareIds })
  };

  onCancelShareMultiChecklist = () => {
    this.setState({checklistsToShareIds: [], checklistSharingMode: false})
  };

  handleShareChecklistWithProject = ({checklist, projectId}) => {
    const { userId, shareChecklist } = this.props;

    if (checklist && checklist.checklistIds && checklist.checklistIds.length) {
      shareChecklist({userId, projectId, checklistIds: [...checklist.checklistIds]})
    } else {
      shareChecklist({userId, projectId, checklistIds: [get(checklist, 'id')]})
    }

    this.setState({checklistsToShareIds: [], checklistSharingMode: false})
  };

  initiateShareMode = () => {
    this.setState({
      checklistSharingMode: !this.state.checklistSharingMode,
      checklistsToShareIds: []
    })
  }

  downloadChecklists = async () => {
    const { checklistProjectId, projectDetails } = this.props;

    if (checklistProjectId) {
      const url = process.env.NODE_ENV === 'development' ? `http://localhost:8080/getProjectChecklistTemplatesCsv` : `${search.host}/getProjectChecklistTemplatesCsv`;

      const res = await axios.post(url, {
            projectId: checklistProjectId,
          },
          {
            responseType: 'arraybuffer',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            }
          });

      const URLd = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = URLd;
      link.setAttribute('download', `${projectDetails.title}----${projectDetails.id}.xlsx`);
      document.body.appendChild(link);
      link.click();
    }
  }

  selectChecklistForSharing = (checklistId) => {
    const checklistsToShareIdsCopy = [...this.state.checklistsToShareIds];

    const index = checklistsToShareIdsCopy.indexOf(checklistId);
    if (index === -1) {
      checklistsToShareIdsCopy.push(checklistId);
    } else {
      checklistsToShareIdsCopy.splice(index, 1)
    }

    this.setState({checklistsToShareIds: checklistsToShareIdsCopy });
  }

  clearActiveChecklist = () => {
    this.setActiveChecklist(null);
  };

  onEditCard = card => {
    const { userId, editChecklistItem, getChecklist } = this.props;
    const { columns, activeElement } = this.state;

    editChecklistItem(userId, activeElement.indexColumn, card).then(() => {
      getChecklist(userId);
    });

    this.setState({
      activeElement: null
    });
  };

  onDeleteCard = ({ indexColumn, id }) => {
    const { userId, getChecklist, deleteChecklistItem } = this.props;
    const { columns } = this.state;
    deleteChecklistItem(userId, indexColumn, id).then(() => {
      getChecklist(userId);
    });

    this.setState({
      activeElement: null
    });
  };

  onDeleteChecklist = ({ indexColumn }) => {
    const { userId, deleteChecklist, getChecklist } = this.props;
    deleteChecklist(userId, indexColumn).then(() => {
      getChecklist(userId);
    });
  };

  onCopyChecklist = ({ indexColumn, index }) => {
    const { userId, copyChecklist, getChecklist } = this.props;
    copyChecklist(userId, indexColumn, index).then(() => {
      getChecklist(userId);
    });
  };

  onDownloadChecklist = ({ indexColumn }) => {
    const {
      checklists: { lists }
    } = this.props;
    const checklist = lists[indexColumn];

    const newItems = {};

    checklist.order.forEach(v => {
      newItems[v] = checklist.items[v];
    });

    checklist.items = Object.assign({}, newItems);

    const formattedChecklist = {
      ...checklist,
      text: '',
    };

    formattedChecklist.items = Object.values(formattedChecklist.items);
    const checklistMeta = {
      [IMPORT_FIELD_NAMES.checklistTitle]: checklist.title ? checklist.title : '',
      [IMPORT_FIELD_NAMES.checklistGroup]: checklist.group ? checklist.group : '',
      [IMPORT_FIELD_NAMES.checklistLogoUrl]: checklist.logoUrl ? checklist.logoUrl : '',
    };

    formattedChecklist.items = formattedChecklist.items.map((item) => {
      return {
        [IMPORT_FIELD_NAMES.description]: item.description ? item.description : '',
        [IMPORT_FIELD_NAMES.section]: item.section ? item.section : '',
        [IMPORT_FIELD_NAMES.standard]: item.standard ? item.standard : '',
        [IMPORT_FIELD_NAMES.must]: item.isMust ? item.isMust : false,

        ...checklistMeta
      }
    });

    const filename = `${formattedChecklist.title}.csv`;
    json2csv(formattedChecklist.items, (err, csv) => {
      if (err) console.error(csv);

      fileDownload(csv, filename, "text/csv");
    });
  };

  validateLimitCard = indexColumn => {
    const { columns } = this.state;
    const length = get(columns[indexColumn], 'order.length');
    // if (length >= 50) {
    //     NotificationManager.error("Max number of checklist items is 50", "Error");
    //   return false;
    // }
    return true;
  };

  onSetCardIndex = index => {
    const isValid = this.validateLimitCard(index.indexColumn);

    isValid && this.setState({ activeElement: index });
  };

  onClearActiveElement = () => {
    this.setState({ activeElement: null });
  };

  onDragEnd = result => {
    const { source, destination, draggableId } = result;
    const { ordered, columns } = this.state;
    const {
      userId,
      checklists,
      moveChecklist,
      getChecklist,
      moveChecklistItemInParent,
      moveChecklistItemToOtherList
    } = this.props;

    if (!result.destination) {
      return;
    }

    if (result.type === "COLUMN") {
      moveChecklist(userId, source.index, destination.index).then(() => {
        getChecklist(userId);
      });
      const newOrdered = arrayMove(ordered, source.index, destination.index);
      this.setState({ ordered: newOrdered });
    }

    if (result.type === "CARD") {
      let selectedTaskIds = [ ...this.state.selectedTaskIds ];

      if (selectedTaskIds.length === 0) {
        selectedTaskIds.push(result.draggableId);
      }

      if (source.droppableId === destination.droppableId) {

        let sourceIndex = [parseInt(source.index, 10)];
        this.state.selectedTaskIds.forEach(id => {
          if (result.draggableId !== id) {
            sourceIndex.push(columns[source.droppableId].order.findIndex((i) => i === id));

          }
        })

        const destinationIndex = insertAtIndex({
          selectedTaskIds,
          columns,
          source,
          destination
        });

        moveChecklistItemInParent(
            userId,
            source.droppableId,
            sourceIndex,
            destinationIndex,
            selectedTaskIds
        ).then(() => {
          getChecklist(userId);
        });

        this.setState({selectedTaskIds: [], selectedColumnId: false});
      } else {

        const itemsData = []; //checklists.lists[source.droppableId].items[draggableId];

        selectedTaskIds.forEach((id) => {
          itemsData.push(checklists.lists[source.droppableId].items[id]);
        })

        moveChecklistItemToOtherList(
          userId,
          source.droppableId,
          destination.droppableId,
          itemsData,
          destination.index
        ).then(() => {
          getChecklist(userId);
        });

        this.setState({selectedTaskIds: [], selectedColumnId: false});
      }
    }
  };

  onAddNewList = async ({ title, logoUrl, text, group }) => {
    const {
      // checkslits,
      addChecklist,
      userId,
      getChecklist,
      track
    } = this.props;

    await addChecklist(userId, {
      title: title || 'New checklist',
      logoUrl,
      text,
      group
    });
    track("Web app: Checklist created");

    await getChecklist(userId);
  };

  execPropsDialog = () => {
    const { activeElement, section, isMust } = this.state;
    if (!activeElement) return {};

    if (activeElement.card.id === 0) {
      return {
        card: { ...activeElement.card },
        onConfirm: this.onCreateCard,
        onAddNew: this.handleSaveDataToPrefillModal,
        prefillData: {
          section,
          isMust
        }
      }
    }

    return {
      card: { ...activeElement.card },
      onConfirm: this.onEditCard,
    }
  };

  // toggleSelection = (taskId, column) => {
  //   const selectedTaskIds = this.state.selectedTaskIds;
  //   const wasSelected = selectedTaskIds.includes(taskId);
  //
  //   const newTaskIds = (() => {
  //     // Task was not previously selected
  //     // now will be the only selected item
  //     if (!wasSelected) {
  //       return [taskId];
  //     }
  //
  //     // Task was part of a selected group
  //     // will now become the only selected item
  //     if (selectedTaskIds.length > 1) {
  //       return [taskId];
  //     }
  //
  //     // task was previously selected but not in a group
  //     // we will now clear the selection
  //     return [];
  //   })();
  //
  //   this.setState({
  //     selectedTaskIds: newTaskIds,
  //   });
  // };

  toggleSelectionInGroup = (taskId, columnId) => {
    const selectedTaskIds = this.state.selectedTaskIds;
    const index = selectedTaskIds.indexOf(taskId);

    if (this.state.selectedColumnId && this.state.selectedColumnId !== columnId) {
      return;
    }

    // if not selected - add it to the selected items
    if (index === -1) {
      this.setState({
        selectedTaskIds: [...selectedTaskIds, taskId],
        selectedColumnId: columnId
      });
      return;
    }

    // it was previously selected and now needs to be removed from the group
    const shallow = [...selectedTaskIds];
    shallow.splice(index, 1);
    this.setState({
      selectedTaskIds: shallow
    });
  };

  // This behaviour matches the MacOSX finder selection
  // multiSelectTo = (newTaskId: Id) => {
  //   const updated = multiSelect(
  //       this.state.entities,
  //       this.state.selectedTaskIds,
  //       newTaskId,
  //   );
  //
  //   if (updated == null) {
  //     return;
  //   }
  //
  //   this.setState({
  //     selectedTaskIds: updated,
  //   });
  // };

  render() {
    const { activeElement, columns, ordered, activeChecklist } = this.state;
    const { checklists, containerHeight, userId, firstLoad, isProjectOwner, isChanged, isLoaded, history, checklistProjectId } = this.props;
    const propDialog = this.execPropsDialog();

    const board = (
      <Droppable
        droppableId="board"
        type="COLUMN"
        direction="horizontal"
        ignoreContainerClipping={Boolean(containerHeight)}
        isCombineEnabled={this.props.isCombineEnabled}
        isDropDisabled={!isProjectOwner}
      >
        {provided => (
          <div
            className="container"
            ref={provided.innerRef}
            {...provided.droppableProps}
            style={{
              width: ordered.length * 300 + 50 + "px",
              height: "100vh"
            }}
          >
            {ordered.map((key, index) => {
              if (columns[key]) {
                return (
                  <ChecklistGroup
                    onEditCheklist={() => this.setActiveChecklist(columns[key])}
                    column={columns[key].items}
                    onAddEdit={this.onSetCardIndex}
                    onDelete={this.onDeleteCard}
                    onDeleteChecklist={this.onDeleteChecklist}
                    onCopyChecklist={this.onCopyChecklist}
                    onDownloadChecklist={this.onDownloadChecklist}
                    onShareChecklist={() => this.onShareChecklist(columns[key])}
                    key={key}
                    columnId={columns[key].id}
                    index={index}
                    title={columns[key]}
                    quotes={columns[key].order ? columns[key].order : []}
                    isScrollable={false}
                    isCombineEnabled={this.props.isCombineEnabled}
                    isDropDisabled={!isProjectOwner}

                    isSharingMode={this.state.checklistSharingMode}
                    checklistsToShareIds={this.state.checklistsToShareIds}
                    selectForSharing={this.selectChecklistForSharing}

                    selectedTaskIds={this.state.selectedTaskIds}
                    toggleSelectionInGroup={this.toggleSelectionInGroup}
                    toggleSelection={this.toggleSelection}
                    multiSelectTo={this.multiSelectTo}
                  />
                )
              }
            })}
          </div>
        )}
      </Droppable>
    );

    return (
      <div style={{ marginTop: "90px", marginLeft: "90px" }}>
        {firstLoad ? (
          <div className="wrap-spiner-checklist">
            <ActivityIndicator
              number={5}
              diameter={40}
              duration={100}
              activeColor="#5BA22F"
              borderColor="white"
              borderWidth={5}
              borderRadius="50%"
            />
          </div>
        ) : (
          <React.Fragment>
            <ChecklistCreator
              onAddNewList={this.onAddNewList}
              activeChecklist={activeChecklist}
              onClose={this.clearActiveChecklist}
              onEdit={this.onEditCheklist}
              onShareChecklist={this.handleShareChecklistWithProject}
              initiateShareMode={this.initiateShareMode}
              downloadChecklists={this.downloadChecklists}
              isSharingMode={this.state.checklistSharingMode}
              history={history}
            />

            {get(checklists, "lists") && (
              <DragDropContext onDragEnd={this.onDragEnd}>
                <div
                  style={{
                    width: "calc(100vw - 90px)",
                    overflowX: "auto",
                    height: "calc(100vh - 90px)"
                  }}
                >
                  <div
                    className="parent-container"
                    style={{ width: ordered.length * 300 + "px" }}
                  >
                    {board}
                  </div>
                </div>
              </DragDropContext>
            )}

            {isLoaded && !get(checklists, "lists") && (
              <div style={{height: 600, alignItems: 'center', justifyContent: 'center'}}>
                <div style={{ textAlign: "center", color: 'black', fontWeight: 700, fontSize: 20 }}>No project checklists yet. </div>
                <div style={{ textAlign: "center", color: 'black', fontSize: 18, marginTop: 10 }}>Please ask project owner (user who opened this project) to add project checklists. Once checklists are added to project – all project members can see them in mobile app under “checklist tab” – add new checklist (green plus icon) – “project checklists” folder</div>
              </div>
            )}

            {!!activeElement && (
              <AddEditCardDialog
                onCancel={this.onClearActiveElement}
                activeElement={this.state.activeElement}
                {...propDialog}
              />
            )}

            {this.state.checklistSharingMode &&
              <>
                <FlatButton
                    label={`Cancel sharing`}
                    onClick={this.onCancelShareMultiChecklist}
                    style={{
                      position: "fixed",
                      bottom: 30,
                      right: 250,
                      zIndex: 1300,
                      backgroundColor: '#d3d3d3',
                      color: '#000'
                    }}
                />
                <FlatButton
                  label={`Share checklists (${this.state.checklistsToShareIds.length})`}
                  onClick={this.onShareMultiChecklist}
                  disabled={this.state.checklistsToShareIds.length === 0}
                  style={{
                    position: "fixed",
                    bottom: 30,
                    right: 50,
                    zIndex: 1300,
                    backgroundColor: '#6da92e',
                    color: '#fff'
                  }}
                />
              </>
            }
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Checklist);
